/**
 * This function checks the rule - TargetCCY should match either SendingCCY or ReceivingCCY, unless the targetCCY is CNH and
 * either the sending or receiving CCY is CNY, in which case they are treated as equivalent.
 * Perform a safety check to double check whether necessary updates have been made by logics implemented in other blocks.
 */
export const performValidationCheckForTargetCCYMatching = (targetCCY, sendingCCY, receivingCCY) => {
    return targetCCY == sendingCCY ||
        targetCCY == receivingCCY ||
        (targetCCY === 'CNH' && (sendingCCY === 'CNY' || receivingCCY === 'CNY'))
}